// "Pick your kit" cards: the color dots pick the variant. The photo, price and Add to cart follow the choice.
const money = (cents) =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

document.addEventListener('click', (event) => {
  const dot = event.target.closest('[data-bg-card-color]');
  if (!dot) return;
  const card = dot.closest('.bg-kit-card');
  if (!card) return;
  card.querySelectorAll('[data-bg-card-color]').forEach((d) => d.setAttribute('aria-pressed', String(d === dot)));

  const img = card.querySelector('.bg-kit-media img');
  if (img && dot.dataset.img) {
    img.src = dot.dataset.img;
    img.srcset = dot.dataset.srcset || '';
  }

  const priceEl = card.querySelector('[data-bg-card-price]');
  if (priceEl) {
    const price = Number(dot.dataset.price);
    const compare = Number(dot.dataset.compare) > price ? Number(dot.dataset.compare) : Number(priceEl.dataset.compareTotal) > price ? Number(priceEl.dataset.compareTotal) : 0;
    priceEl.innerHTML = money(price) + (compare ? ` <s>${money(compare)}</s>` : '');
  }

  const add = card.querySelector('[data-bg-add]');
  if (add) {
    const available = dot.dataset.available === 'true';
    add.dataset.bgAdd = dot.dataset.variant;
    add.disabled = !available;
    add.textContent = available ? 'Add to cart' : 'Sold out';
  }
});

